export default __webpack_public_path__ + "ae8129e8e4b9379cb4ca73cd4cfed8b0.png";